import React from 'react';
import { Box, Paper, Typography } from '@material-ui/core';
import { EmojiObjects } from '@material-ui/icons';

import { EColors, RATING_COUNT_LABELS } from '../constants';
import { getBackgroundColorByRatingSum } from '../helpers';

const Recommendations = () => {
  return (
    <Box component={(props) => <Paper {...props} variant="outlined" />} sx={{ display: 'flex', gridGap: 24, p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gridGap: 8 }}>
        <EmojiObjects style={{ color: EColors.YELLOW }} />

        <Typography component="h2" variant="body1">
          <b>Рекомендации:</b>
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gridGap: 24 }}>
        {RATING_COUNT_LABELS.map(({ secondary, value }) => (
          <Box sx={{ display: 'inline-flex', flex: 1, alignItems: 'center' }} key={secondary}>
            <Box
              sx={{
                minWidth: 24,
                height: 24,
                borderRadius: '10em',
                mr: 1,
                bgcolor: getBackgroundColorByRatingSum(value),
              }}
            />

            <Typography variant="body2" color="textSecondary">
              {secondary}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Recommendations;
